import React from 'react';
import { Button } from "@/components/ui/button";
import { getWeekDays, getDayNumber, formatDateKey } from '@/lib/dateUtils';
import { useTheme } from '@/context/ThemeContext';

const DAY_LETTERS = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];

export function DaySelector({ currentDate, onDateChange, calculateDailyDogCount }) {
  const { theme } = useTheme();
  const weekDays = getWeekDays(currentDate);
  const currentDayKey = formatDateKey(currentDate);
  const orderedIndexes = [0, 1, 2, 3, 4, 5, 6];

  console.info('[WEEK_ORDER]', orderedIndexes);

  return (
    <div className="grid grid-cols-7 gap-0.5 sm:gap-1 w-full">
      {orderedIndexes.map((index) => {
        const date = weekDays[index];
        const dateKey = formatDateKey(date);
        const dayLetter = DAY_LETTERS[date.getDay()];
        const dayNumber = getDayNumber(date);
        const dogCount = calculateDailyDogCount(dateKey);
        const isSelected = dateKey === currentDayKey;

        const dayBgStyle = isSelected && theme === 'dark' ? { backgroundColor: 'rgba(115, 182, 255, 0.50)' } : {};
        
        return (
          <Button
            key={dateKey}
            variant={isSelected ? "default" : "outline"}
            onClick={() => onDateChange(date)}
            style={dayBgStyle}
            className={`btn-day whitespace-nowrap w-full min-w-0 flex flex-col h-auto py-1 px-0.5 sm:py-1.5 sm:px-1 ${
              isSelected
                ? "bg-primary/40 text-foreground border border-border hover:bg-primary/50"
                : "bg-card border border-border text-foreground"
            }`}
          >
            <span className="text-xs uppercase">{dayLetter}</span>
            <span className="text-base sm:text-lg font-bold">{dayNumber}</span>
            <span className={`text-xs ${isSelected ? "text-foreground" : "text-muted-foreground"}`}>({dogCount})</span>
          </Button>
        );
      })}
    </div>
  );
}
